// extracted by mini-css-extract-plugin
export default {"Txt":"autoResizableInput_Txt__hf0li","Hide":"autoResizableInput_Hide__mb0yd"};